import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import { Box, Grid, Stack } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { toJS } from "mobx";
import React from "react";
import { LLMConfigurationBuilderProvider } from "../../Components/LLMConfigurationBuilder";
import { LogicChainBuilder } from "../../Components/LogicChainBuilder/LogicChainBuilder";
import { StandardBuilder } from "../../Components/StandardBuilder/StandardBuilder";
import { LLMClassifierBuilderStore } from "../../Stores/LLMClassifierBuilderStore";
import { ChainSourceSection } from "../../Components/ChainSource/ChainSourceSection";
import { ModelChainPanel } from "../../Components/ChainSource/ModelChainPanel";
import { TestModelSection } from "../../Components/ModelTester/TestModelSection";

export const LLMClassifierBuilder = observer(() => {
    return (
        <LLMConfigurationBuilderProvider>
            {/* Wraps on the width actually available rather than on a viewport
                breakpoint, since the nav rail and page padding mean a wide
                viewport does not guarantee room for both columns. Once the row
                cannot fit the two flex bases, the map drops below full width. */}
            <Stack
                direction="row"
                flexWrap="wrap"
                columnGap={2}
                rowGap={2}
                alignItems="flex-start"
                width="100%"
            >
                <Stack
                    direction="column"
                    rowGap={2}
                    sx={{ flex: "999 1 34rem", minWidth: 0 }}
                >
                    <ChainSourceSection />
                    <BuilderSections />
                </Stack>
                {/* Sticky so the map stays in view while editing prompts far
                    down the page, but height bound: a tall chain would
                    otherwise have its bottom pinned off screen with no way to
                    reach it. Drop `position` to let it scroll away instead. */}
                <Box
                    sx={{
                        flex: "1 1 20rem",
                        maxHeight: "calc(100vh - 88px)",
                        maxWidth: "100%",
                        minWidth: 0,
                        overflowY: "auto",
                        position: "sticky",
                        top: "64px",
                    }}
                >
                    <ModelChainPanel />
                </Box>
            </Stack>
        </LLMConfigurationBuilderProvider>
    );
});

const BuilderSections = observer(() => {
    const store = useStore(LLMClassifierBuilderStore);

    return (
        <>
            <TitledSection
                variant="bordered"
                title={
                    <Grid
                        container
                        width="100%"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Grid item>
                            Model Rules
                            {window["enable_debug"] === true &&
                                process.env.NODE_ENV === "development" && (
                                    <AcxButton
                                        onClick={() =>
                                            console.log(
                                                toJS(
                                                    store.classifier
                                                        .implementation,
                                                ),
                                            )
                                        }
                                    >
                                        Log State
                                    </AcxButton>
                                )}
                        </Grid>
                    </Grid>
                }
            >
                {store.classifier.implementation.isStandard() && (
                    <StandardBuilder />
                )}
                {store.classifier.implementation.isLogicChain() && (
                    <LogicChainBuilder />
                )}
            </TitledSection>
            <TestModelSection />
        </>
    );
});
